module.exports = __webpack_public_path__ + "img/5.4cb1eee9.png";